import { useSortable } from '@dnd-kit/sortable';
// import { CSS } from '@dnd-kit/utilities';

// import { FolderManagerMimeTypes } from '../interfaces';

interface ItemWithDnD {
  type: string;
  id: string | number;
  _index?: number;
}

interface useDnDItemProps<T extends ItemWithDnD> {
  item: T;
  selectedRows: FolderManagerItem[];
  overId: string | number | undefined | null;
  thumbnailUrl?: string;
}

export const useDnDSortableItem = <T extends ItemWithDnD>({ item, selectedRows, overId, thumbnailUrl }: useDnDItemProps<T>) => {
  if (!item) {
    console.error('Item not provided');
    return;
  }

  const sortableId = item._index !== undefined ? item._index : item.id;

  // const isFolder = item?.type === FolderManagerMimeTypes.FOLDER || item?.type === FolderManagerMimeTypes.WORKSPACE;
  const isOver = overId !== undefined && overId !== null && String(overId) === String(sortableId);

  const isSelected = (selectedRows || []).some((row: any) => {
    // check instanceId first for duplicate items support
    if ((row as any).instanceId && (item as any).instanceId) {
      return row.instanceId === (item as any).instanceId;
    }
    // fall back to _index or id comparison
    return row._index !== undefined ? row._index === item._index : row.id === item.id && row.type === item.type;
  });

  const { attributes, listeners, setNodeRef, isDragging } = useSortable({
    id: String(sortableId),
    data: {
      type: item?.type,
      item: item,
      thumbnailUrl: thumbnailUrl,
    },
  });

  // don't apply transform to prevent reordering animation
  const style = {
    transform: undefined,
    transition: undefined,
  };

  return {
    isOver: isOver,
    attributes: attributes,
    listeners: listeners,
    setNodeRef: setNodeRef,
    isDisabled: false,
    isDragging: isDragging,
    isSelected: isSelected,
    itemStyle: style,
  };
};
